import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {observer} from "mobx-react";
import FormFieldBase from "./FormFieldBase";
import {useTheme} from "@mui/material";
import 'dayjs/locale/es';
import dayjs from "dayjs";

function setDatePickerLanguageToSpanish() {
    dayjs.locale('es');
}

function FormDateField({label, field, disabled = false, isDateDisabled = (date) => false, minDate = null}) {
    const theme = useTheme();
    const dateFormat = 'DD-MM-YYYY';
    setDatePickerLanguageToSpanish();

    return (
        <FormFieldBase style={{borderRadius: '0.5rem'}}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={dayjs.locale()}>
                <DatePicker
                    fullWidth
                    InputLabelProps={{shrink: false}}
                    sx={{
                        backgroundColor: theme.brand.field,
                        borderRadius: '0.5rem',
                        width: '100%',
                        '& .MuiInputLabel-root, & .MuiInputLabel-shrink, & .MuiOutlinedInput-root': {
                            fontSize: '.8rem',
                        }
                    }}
                    value={field.value}
                    format={dateFormat}
                    label={label}
                    onChange={(date) => {
                        field.updateValue(date)
                    }}
                    disabled={disabled}
                    shouldDisableDate={(date) => isDateDisabled(date)}
                    minDate={minDate}
                    slotProps={{
                        textField: {
                            error: field.hasErrors,
                            helperText: field.hasErrors ? field.errors[0] : undefined,
                        },
                    }}
                />
            </LocalizationProvider>
        </FormFieldBase>
    )
}

export default observer(FormDateField);